import { MARKET_SLUGS } from '$lib/services/market/slugs';
import type { TMarketSlug } from '$lib/services/market/types';

export type TErrorMessage = {
    title: string;
    info: string;
    buttonText: string;
};

type TErrorMessages = Record<TMarketSlug, TErrorMessage>;

export const ERROR_MESSAGES: Partial<TErrorMessages> = {
    [MARKET_SLUGS.ES]: {
        title: '¡Ups! Página no encontrada.',
        info: 'Lo sentimos, la página que buscas no existe o ha sido eliminada. Revisa si hay algún error en la URL o regresa a la página de inicio y echa un vistazo.',
        buttonText: 'Volver a inicio.'
    },
    [MARKET_SLUGS.FI]: {
        title: 'Hups! Sivua ei löydy',
        info: 'Valitettavasti etsimääsi sivua ei ole olemassa tai se on poistettu. Tarkista, onko URL-osoitteessa kirjoitusvirheitä tai palaa etusivulle ja etsi uudestaan.',
        buttonText: 'Takaisin etusivulle'
    },
    [MARKET_SLUGS.SV]: {
        title: 'Oops, sidan hittades inte.',
        info: 'Tyvärr, den sida du söker finns inte eller har tagits bort. Kontrollera om det finns fel i webbadressen eller gå tillbaka till startsidan och titta efter.',
        buttonText: 'Tillbaka till startsidan'
    },
    [MARKET_SLUGS.NO]: {
        title: 'Oops! Siden ble ikke funnet',
        info: 'Beklager, siden du leter etter finnes ikke eller har blitt fjernet. Dobbeltsjekk om det er feilstaving i URL-en, eller gå tilbake til startsiden og se deg rundt.',
        buttonText: 'Tilbake Hjem'
    },
    [MARKET_SLUGS.EN]: {
        title: 'Oops! Page not found',
        info: 'Sorry, the page you are looking for doesn’t exist or has been moved. Checkout for any URL misspelling or head back to home page and look around.',
        buttonText: 'Back Home'
    }
};
